/**
 * Parses PayPal SDK errors and returns a user-friendly message.
 * Handles PAYEE_ACCOUNT_RESTRICTED (merchant account restricted/verification)
 * and suggests workarounds for browser/privacy issues.
 * @returns {{ message: string, keepPayPalVisible: boolean }}
 */
export function getPayPalError(err) {
  if (!err) {
    return { message: 'Payment error occurred. Please try again.', keepPayPalVisible: false };
  }

  const msg = typeof err?.message === 'string' ? err.message : String(err);
  const str = msg + (err?.details ? JSON.stringify(err.details) : '');

  // Merchant/receiving account is restricted (verification, limits, compliance)
  if (str.includes('PAYEE_ACCOUNT_RESTRICTED') || (str.includes('payee') && str.includes('restricted'))) {
    return {
      message: 'Our payment account is currently being verified. Please contact us directly to complete your booking, or try again in a few days.',
      keepPayPalVisible: true
    };
  }

  // Other known PayPal validation/merchant issues
  if (str.includes('UNPROCESSABLE_ENTITY') || str.includes('422')) {
    return {
      message: 'The payment could not be processed. Please contact us to complete your booking.',
      keepPayPalVisible: true
    };
  }

  // Generic – mention privacy/tracking in case of 406 or tracking prevention
  return {
    message: 'Payment error occurred. If you use strict privacy settings or an ad blocker, try disabling it for this site. Otherwise, please try again or contact us to complete your booking.',
    keepPayPalVisible: false
  };
}
